<template>
    <div>
        <v-form ref="form">
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                        v-model="params.tipo_imovel"
                        :items="items.tipos_imovel"
                        item-text="tipo"
                        item-value="tipo"
                        outlined
                        dense
                        multiple
                        clearable
                        :class="$css_field"
                        @change="searchSubTipoImovel"
                        required
                        :rules="[rules.multilple_required]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Tipo Imovel</span>
                        </template>

                        <template v-slot:selection="{ item, index }">
                            <div class="mr-1" v-if="index === 0">
                                <span :class="$css_field">{{ item.tipo }}</span>
                            </div>
                            <span
                            v-if="index === 1"
                            :class="$css_field"
                            >
                                (+{{ params.tipo_imovel.length - 1 }} opções)
                            </span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                        v-model="params.sub_tipo_imovel"
                        :items="items.sub_tipo_imovel"
                        outlined
                        dense
                        clearable
                        multiple
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Sub Tipo Imovel</span>
                        </template>

                        <template v-slot:selection="{ item, index }">
                            <div :class="$css_field" v-if="index === 0">
                                <span>{{ item }}</span>
                            </div>
                            <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                            >
                                (+{{ params.sub_tipo_imovel.length - 1 }} opções)
                            </span>
                        </template>
                    </v-select>
                </v-col>

                <v-col cols="6" xs="6" sm="6" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.dormitorios"
                        type="number"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Dormitório(s)</span>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="6" xs="6" sm="6" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.banheiros"
                        type="number"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Banheiro(s)</span>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="6" xs="6" sm="6" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.vagas"
                        type="number"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Vaga(s)</span>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="6" xs="6" sm="6" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.area"
                        type="number"
                        outlined
                        dense
                        suffix="m²"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Área Minima</span>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="6" xs="6" sm="6" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="item.area_total"
                        type="number"
                        outlined
                        dense
                        suffix="m²"
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Área Total Minima</span>
                        </template>
                    </v-text-field>
                </v-col>


                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-currency-field
                        v-model="item.valor_minimo"
                        outlined
                        dense
                        prefix="R$"
                        :class="$css_field"
                        clearable
                        :rules="[rules.required, rules.min]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Vl Mínimo</span>
                        </template>
                    </v-currency-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-currency-field
                        v-model="item.valor_maximo"
                        outlined
                        dense
                        prefix="R$"
                        :class="$css_field"
                        clearable
                        :rules="[rules.required, rules.min]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Vl Máximo</span>
                        </template>
                    </v-currency-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-select
                        v-model="item.aceita_permuta"
                        :items="items.sim_nao"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Aceita permuta?</span>
                        </template>
                    </v-select>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-select
                        v-model="item.aceita_financiamento"
                        :items="items.sim_nao"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Aceita financiamento?</span>
                        </template>
                    </v-select>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-select
                        v-model="item.em_condominio"
                        :items="items.sim_nao"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Em condominio?</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                        v-model="item.cidade1"
                        :items="items.cidades"
                        item-text="distinct_col"
                        item-value="distinct_col"
                        outlined
                        dense
                        clearable
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Cidade 1</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                        v-model="item.cidade2"
                        :items="items.cidades"
                        item-text="distinct_col"
                        item-value="distinct_col"
                        outlined
                        dense
                        clearable
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Cidade 2</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.bairro1"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Bairro 1</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.bairro2"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Bairro 2</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.bairro3"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Bairro 3</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.bairro4"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Bairro 4</span>
                        </template>
                    </v-text-field>
                </v-col>

            </v-row>

            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                   <v-btn
                        dark
                        color="purple"
                        @click="checkPropertyProfile()"
                        :class="$css_button"
                    >
                        Cruzar o perfil com os imóveis
                    </v-btn>
                   
                   <v-btn
                        dark
                        color="primary"
                        @click="validate()"
                        :class="$css_button + ' ml-2'"
                    >
                        Gravar
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>

        <v-row v-if="properties && properties.length > 0" class="mt-3">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">  
                <v-alert 
                    text
                    dense
                    color="warning"          
                    icon="mdi-alert-outline"    
                >
                    <span class="black--text mr-2"> A pesquisa automática entre FAC e Imóveis esta limitada até 30 registros. Para visualizar, mais imóveis entre na pesquisa de imóvel. </span>
                </v-alert>


                <v-card
                    class="mx-auto"
                    outlined
                >
                    <v-data-table
                        :hide-default-header="$vuetify.breakpoint.xsOnly"
                        :headers="headers"
                        :items="properties"
                        :items-per-page="10"
                        class="elevation-1 table-striped"
                        :footer-props="{
                        'items-per-page-text':'Itens por página',
                        'items-per-page-options': [5, 10],
                        'items-per-page-all-text': '',
                        'page-text': '{0}-{1} de {2}'
                    }"
                    >   
                        <template v-slot:[`item.description`]="{ item }">
                           <v-row class="pa-1">
                                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <slide-single :items="item.photos_total" class="ma-1" />
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                    <v-row dense>
                                        <!-- Codigo e datas -->
                                        <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                                <span>
                                                    <v-chip
                                                        color="blue"
                                                        label
                                                        text-color="white"
                                                        class="font-weight-medium text-h7"
                                                    >
                                                    COD: {{ item.codigo }} 
                                                    </v-chip>   
                                                </span>
                                                <span class="ml-2">
                                                    <v-chip
                                                        :color="item.status | statusProperty"
                                                        label
                                                        text-color="black"
                                                        class="font-weight-medium text-h7"
                                                    >
                                                        {{ item.status }}
                                                    </v-chip> 
                                                </span>
                                                <span class="ml-2 text-h7 black--text font-weight-medium">
                                                    {{ item.tipo_imovel }}
                                                    <span v-if="item.tipo_imovel == 'Conjunto'"> {{ item.finalidade }}</span> 
                                                    <span v-if="(showSubTipoImovel(item) != '')"> 
                                                        ( {{showSubTipoImovel(item)}} )
                                                    </span> 
                                                </span>   
                                        </v-col>         
                                    </v-row>
                                    <!-- Fim codigo e datas -->


                                    <!-- endereco -->
                                    <v-row dense>
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="min-height: 70px;">
                                            <div :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 font-weight-light black--text' : 'text-subtitle-1 font-weight-light black--text'">
                                                {{ item.endereco }}
                                                <span v-if="item.numero">, {{ item.numero }} </span>
                                                <span v-if="item.apartamento"> - Apto: {{ item.apartamento }} </span>
                                                <span v-if="item.andar">  - {{ item.andar }} andar </span>
                                                <span v-if="item.tower && item.tower.nome != ''"> - Torre: {{ item.tower.nome }} </span>
                                                <span v-if="item.complemento"> - Compl: {{ item.complemento }} </span>
                                                <span v-if="item.bairro">  - {{ item.bairro }} </span>
                                                <span v-if="item.cidade">  - {{ item.cidade }} </span>
                                                <span v-if="item.estado">  - {{ item.estado }} </span>
                                                <span v-if="item.cep">  - {{ item.cep | VMask('#####-###') }} </span>
                                            </div> 
                                        </v-col>                                        
                                    </v-row>  
                                    <!-- fim endereco -->

                                    <!-- dados principais buttons -->
                                    <v-row dense>
                                        <v-col cols="auto" v-if="item.area">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                                block
                                            >
                                                <span>{{ item.tipo_imovel | labelArea('area') }} {{ item.area }} m²</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.area_total">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                                <span>{{ item.tipo_imovel | labelArea('area_total') }} {{ item.area_total }} m²</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.area_construida_terreno">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                                <span>A. const. terr. {{ item.area_construida_terreno }} m²</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.dormitorios">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label 
                                                outlined
                                                color="black"
                                                dark
                                            >
                                            <span>{{ item.dormitorios }} dorm(s)</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.suites">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                            <span>{{ item.suites }} suite(s)</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.banheiros">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                            <span>{{ item.banheiros }} banheiro(s)</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.vagas">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                            <span>{{ item.vagas }} vaga(s)</span> 
                                            </v-chip>
                                        </v-col> 
                                    </v-row>  
                                    <!-- fim dados principais buttons -->  


                                    <!-- valores -->
                                    <v-row dense>
                                        <v-col cols="auto" v-if="item.valor_venda && item.valor_venda > 0" :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 black--text' : 'text-h6 black--text'">
                                            Venda {{ item.valor_venda | toCurrency }}
                                        </v-col> 
                                        <v-col cols="auto" v-if="item.valor_locacao && item.valor_locacao > 0" :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 black--text' : 'text-h6 black--text'">
                                            Locaçāo {{ item.valor_locacao | toCurrency }}
                                        </v-col>
                                        <v-col cols="auto" v-if="item.valor_condominio && item.valor_condominio > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                            Cond. {{ item.valor_condominio | toCurrency }}
                                        </v-col>
                                        <v-col cols="auto" v-if="item.valor_iptu && item.valor_iptu > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                            IPTU {{ item.valor_iptu | toCurrency }}
                                        </v-col> 
                                        <v-col cols="auto" v-if="item.valor_locacao && item.valor_locacao > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                            Total {{ setTotal(item) | toCurrency }}
                                        </v-col>  
                                    </v-row>
                                    <!-- fim valores -->

                                    <v-row
                                        dense
                                    >
                                        <v-col cols="auto">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn 
                                                        v-bind="attrs" v-on="on" 
                                                        :class="$css_button" 
                                                        :small="$vuetify.breakpoint.smAndDown" 
                                                        depressed 
                                                        outlined 
                                                        @click.prevent="showItem(item.id)"
                                                    >
                                                        <v-icon left>mdi-eye</v-icon> Ficha
                                                    </v-btn>
                                                </template>
                                                <span>Visualizar Ficha</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-card-actions>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click.prevent="showItem(item.id)" class="ml-2">
                                            <v-icon v-bind="attrs" v-on="on">mdi-eye</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Visualizar</span>
                                </v-tooltip>

                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click.prevent="destroy(item.property_relation_id)" class="ml-8">
                                            <v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Excluir</span>
                                </v-tooltip>
                            </v-card-actions>     
                        </template>

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row> 


        <!-- Dialog -->
        <v-dialog 
            v-if="property && property != ''"
            v-model="dialog.show" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                dark
                color="primary"
                height="10px"
            >    
            </v-system-bar>    

            <v-card class="d-print-none background" >
                <v-card-title class="text-h5">
                    <span v-if="property.codigo">Código {{property.codigo}} - {{ property.tipo_imovel }} <span v-if="property.sub_tipo_imovel"> ({{ property.sub_tipo_imovel }})</span> </span>
                    <v-spacer></v-spacer>
                    
                    <button-share-component class="mr-4" :object="property"></button-share-component>
                    
                    <v-btn icon @click="openCloseDialog('show')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <property-show :object="property" />   
                        </v-col>
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->


    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {SIM_NAO_ITEMS, TIPO_IMOVEL_PROPERTY_ITEMS} from '@/components/properties/config_properties/config_properties.js'
import PropertyShow from '@/components/properties2/PropertyShow.vue';
import SlideSingle from '@/components/slideshow/SlideSingle.vue';

export default {
    components: {
        PropertyShow,
        SlideSingle
    },

    created() {
        this.setObject()
        this.property_distinct()
    },

    props: {
        object: {
            require: false,
        },

        fac: {
            require: true,
        },
    }, 

    computed: {
        ...mapGetters('permissions', ['can']),
        
        me () {
            return this.$store.state.auth.me
        },
    },    

    watch: {
        object () {  
            this.setObject() 
        }
    },

    data () {
        return {
            params: {
                sub_tipo_imovel: [],
            },

            item: {},
            
            items: {
                tipos_imovel: TIPO_IMOVEL_PROPERTY_ITEMS,
                sub_tipo_imovel: [],
                sim_nao: SIM_NAO_ITEMS,
                cidades: []
            },
  
            rules: {
                required: value => !!value || 'Obrigatório',
                multilple_required: value => value.length > 0 || 'Obrigatório',
                min:  v => (v && v.length > 5) || 'Maior que R$ 100',
            },

            properties: [],

            property: {},

            dialog: {
                show: false
            },

            headers: [
                { text: 'DESCRIÇĀO', align: 'start', value: 'description', sortable: false},
            ],
        }
    },

    methods: {
        setObject(){
            if(this.object.length > 0){
                this.item = this.object[0]
                if(this.item.tipo_imovel != ''){
                    this.params.tipo_imovel = this.converteStringToArray(this.item.tipo_imovel,',')
                    this.searchSubTipoImovel()
                }
                this.params.sub_tipo_imovel = null;
                if(this.item.sub_tipo_imovel != '' && this.item.sub_tipo_imovel != '[]'){
                    this.params.sub_tipo_imovel = this.converteStringToArray(this.item.sub_tipo_imovel,',')
                }else{
                    this.item.sub_tipo_imovel = null
                }
            }
        },

        searchSubTipoImovel(){
            this.items.sub_tipo_imovel = []
            this.params.tipo_imovel.forEach(element => {
                var sub = this.items.tipos_imovel.filter(model => model.tipo === element)
                if(sub.length > 0 && sub[0].subtipos.length > 0){
                    sub[0].subtipos.forEach(element => {
                        this.items.sub_tipo_imovel.push(element)
                    });
                    
                }
                
            });
        },

        property_distinct(){
            const params = {}
            params.distinct_col = 'cidade'

            this.$store.dispatch('property_distinct', params)
                        .then(response => {
                            this.items.cidades = response.data   
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        },

        validate () {
            if (this.$refs.form.validate()) {
                this.storeUpdate(this.item)
            }
        },

        storeUpdate(item){
            item.fac_id = this.item.id
            item.tipo_imovel = this.params.tipo_imovel
            //item.sub_tipo_imovel = this.params.sub_tipo_imovel

            if (Array.isArray(this.params.sub_tipo_imovel) && this.params.sub_tipo_imovel.length > 0) {
                item.sub_tipo_imovel = this.params.sub_tipo_imovel;
            } else {
                item.sub_tipo_imovel = null;
            }

            const action = item.id ? 'updatePropertyProfile' : 'storePropertyProfile' 
            this.$store.dispatch(action, item)
                        .then(response => {
                            this.$snotify.success('Cadastro com sucesso!');
                            this.properties = [];
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
                   
        }, 

        showItem (id) {    
            this.$store.dispatch('loadProperty', id) 
                        .then(response => {
                            this.property = response.data
                            this.dialog.show = true
                        })
                                   
        },

        openCloseDialog(window){
            if(window == 'show'){
                this.dialog.show = !this.dialog.show 
            }
        },

        checkPropertyProfile(){
            const params = {};
            params.multiple_setor = [];
            params.valor_locacao_from = 0;
            params.valor_locacao_to = 0;
            params.valor_venda_from = 0;
            params.valor_venda_to = 0;

            if(this.fac.finalidade == 'Alugar um imóvel'){
                params.multiple_setor.push('Locação');
                params.valor_locacao_from = this.item.valor_minimo;
                params.valor_locacao_to = this.item.valor_maximo;
                params.order = 'properties.valor_locacao';
            }else{
                params.multiple_setor.push('Venda');
                params.valor_venda_from = this.item.valor_minimo;
                params.valor_venda_to = this.item.valor_maximo;
                params.order = 'properties.valor_venda';
            }

            params.multiple_tipo_imovel = this.item.tipo_imovel && this.item.tipo_imovel != null ? (Array.isArray(this.item.tipo_imovel) ? this.item.tipo_imovel : this.item.tipo_imovel.split(',')) : [];
            params.aceita_financiamento = this.item.aceita_financiamento;
            params.aceita_permuta = this.item.aceita_permuta;
            params.area_from = this.item.area;
            params.area_total_from = this.item.area_total;
            params.banheiros = this.item.banheiros;
            params.cidade1 = this.item.cidade1;
            params.cidade2 = this.item.cidade2;
            params.dormitorios = this.item.dormitorios;
            params.em_condominio = this.item.em_condominio;
            params.sub_tipo_imovel = this.item.sub_tipo_imovel && this.item.sub_tipo_imovel != null ? (Array.isArray(this.item.sub_tipo_imovel) ? this.item.sub_tipo_imovel : this.item.sub_tipo_imovel.split(',')) : [];
            params.vagas = this.item.vagas;
            params.bairro1 = this.item.bairro1;
            params.bairro2 = this.item.bairro2;
            params.bairro3 = this.item.bairro3;
            params.bairro4 = this.item.bairro4;

            params.multiple_status = ['Ativo','Desatualizado'];
            params.paginate = 'false';
            params.limit = 30;
            this.$store.dispatch('loadPromisseProperties', params) 
                        .then(response => {
                            this.properties = response.data;
                        });
        }
    },
}
</script>